import { formatClock } from '../utils/time.ts';

interface Props {
  now: Date | undefined;
  /** IANA timezone for display (per-channel, set in admin). */
  timeZone: string;
}

/** NTP wall clock. Value is computed upstream in useInterpolatedTiming. */
export function Clock({ now, timeZone }: Props) {
  return (
    <div className="text-right">
      <div className="font-mono text-3xl tabular-nums tracking-tight sm:text-4xl sm:tracking-wider md:text-5xl lg:text-6xl">
        {now ? formatClock(now, timeZone) : '--:--:--'}
      </div>
    </div>
  );
}
